export default "__VITE_ASSET__CxzpSenN__"